import { TenantListItem } from '../api/queries';
import { formatNumber } from './numberFormatters';

/**
 * Checks if a tenant is owned by Trustpulse (no partner association).
 *
 * @param tenant - The tenant to check
 * @returns true if the tenant is a Trustpulse tenant, false otherwise
 */
export const isTrustpulseTenant = (tenant: TenantListItem): boolean => {
  return !tenant.partnerName;
};

/**
 * Checks if a tenant is owned by a partner.
 *
 * @param tenant - The tenant to check
 * @returns true if the tenant is a partner tenant, false otherwise
 */
export const isPartnerTenant = (tenant: TenantListItem): boolean => {
  return !!tenant.partnerName;
};

/**
 * Calculates available seats for a tenant.
 * Returns "Ubegrenset" for unlimited seats.
 *
 * @param availableSeats - Total available seats (null = unlimited)
 * @param seatsUsed - Number of seats currently in use
 * @returns Formatted string representing available seats
 */
export const calculateAvailableSeats = (
  availableSeats: number | null,
  seatsUsed: number
): string => {
  if (availableSeats === null) return 'Ubegrenset';
  return formatNumber(availableSeats - seatsUsed);
};

/**
 * Calculates remaining SMS quota for a tenant.
 * Returns "Ubegrenset" for unlimited quota.
 *
 * @param smsQuota - Total SMS quota (null = unlimited)
 * @param smsUsed - Number of SMS already used
 * @returns Formatted string representing remaining SMS
 */
export const calculateRemainingSms = (
  smsQuota: number | null,
  smsUsed: number
): string => {
  if (smsQuota === null) return 'Ubegrenset';
  return formatNumber(smsQuota - smsUsed);
};
